// Footer.jsx
import React from 'react';
import './Pages/PagesCss/Footer.css';
import { useNavigate } from 'react-router-dom';
import logo from './assets/logo.png';

// SVG Icons for Footer
const FooterIcons = {
  Logo: (props) => (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect x="4" y="4" width="24" height="24" rx="6" stroke="currentColor" strokeWidth="2"/>
      <path d="M10 10H22M10 16H18M10 22H14" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    </svg>
  ),
  Facebook: (props) => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M18 2H15C13.6739 2 12.4021 2.52678 11.4645 3.46447C10.5268 4.40215 10 5.67392 10 7V10H7V14H10V22H14V14H17L18 10H14V7C14 6.73478 14.1054 6.48043 14.2929 6.29289C14.4804 6.10536 14.7348 6 15 6H18V2Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  Twitter: (props) => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M22 4C22 4 21.3 6.1 20 7.4C21.6 15.4 14.6 21.4 6.6 19.8C4.5 19.3 2.5 18.1 1 16.5C4.2 17.2 6.7 15.5 8 14C5 13.5 3.5 11 3 9C4 9.5 5 9.5 6 9C3.5 7.5 2.5 4.5 4 2C6.5 4.5 9.5 6 13 6C13 5 13.5 3 15 2C16.5 1 18 2 18 2C18 2 19.5 2.5 20 4C21 3.5 22 3 22 4Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/>
    </svg>
  ),
  LinkedIn: (props) => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M16 8C17.5913 8 19.1174 8.63214 20.2426 9.75736C21.3679 10.8826 22 12.4087 22 14V21H18V14C18 13.4696 17.7893 12.9609 17.4142 12.5858C17.0391 12.2107 16.5304 12 16 12C15.4696 12 14.9609 12.2107 14.5858 12.5858C14.2107 12.9609 14 13.4696 14 14V21H10V14C10 12.4087 10.6321 10.8826 11.7574 9.75736C12.8826 8.63214 14.4087 8 16 8Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M6 9H2V21H6V9Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <circle cx="4" cy="4" r="2" stroke="currentColor" strokeWidth="1.5"/>
    </svg>
  ),
  GitHub: (props) => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M12 2C6.477 2 2 6.477 2 12C2 16.42 4.87 20.17 8.84 21.5C9.34 21.58 9.5 21.27 9.5 21C9.5 20.77 9.5 20.14 9.5 19.31C6.73 19.91 6.14 17.97 6.14 17.97C5.68 16.81 5.03 16.5 5.03 16.5C4.12 15.88 5.1 15.9 5.1 15.9C6.1 15.97 6.63 16.93 6.63 16.93C7.5 18.45 8.97 18 9.54 17.76C9.63 17.11 9.89 16.67 10.17 16.42C7.95 16.17 5.62 15.31 5.62 11.5C5.62 10.39 6 9.5 6.65 8.79C6.55 8.54 6.2 7.5 6.75 6.15C6.75 6.15 7.59 5.88 9.5 7.17C10.29 6.95 11.15 6.84 12 6.84C12.85 6.84 13.71 6.95 14.5 7.17C16.41 5.88 17.25 6.15 17.25 6.15C17.8 7.5 17.45 8.54 17.35 8.79C18 9.5 18.38 10.39 18.38 11.5C18.38 15.32 16.04 16.16 13.81 16.41C14.17 16.72 14.5 17.33 14.5 18.26C14.5 19.62 14.5 20.72 14.5 21C14.5 21.27 14.66 21.59 15.17 21.5C19.14 20.16 22 16.42 22 12C22 6.477 17.523 2 12 2Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  Instagram: (props) => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect x="4" y="4" width="16" height="16" rx="4" stroke="currentColor" strokeWidth="1.5"/>
      <circle cx="18" cy="6" r="1.5" fill="currentColor"/>
      <circle cx="12" cy="12" r="4" stroke="currentColor" strokeWidth="1.5"/>
    </svg>
  ),
  Mail: (props) => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect x="2" y="4" width="20" height="16" rx="2" stroke="currentColor" strokeWidth="1.5"/>
      <path d="M22 7L12 14L2 7" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
  Location: (props) => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M12 22C12 22 20 16 20 10C20 7.87827 19.1571 5.84344 17.6569 4.34315C16.1566 2.84285 14.1217 2 12 2C9.87827 2 7.84344 2.84285 6.34315 4.34315C4.84285 5.84344 4 7.87827 4 10C4 16 12 22 12 22Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <circle cx="12" cy="10" r="3" stroke="currentColor" strokeWidth="1.5"/>
    </svg>
  ),
  ChevronRight: (props) => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M6 12L10 8L6 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ),
};

const Footer = () => {
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    products: [
      { name: 'Merge PDF', path: '/PDFMerger' },
      { name: 'Split PDF', path: '/PDFSplit' },
      { name: 'Compress PDF', path: '/PDFCompress' },
      { name: 'PDF to Word', path: '/PDFToWord' },
      { name: 'Word to PDF', path: '/WordToPDF' },
      { name: 'Protect PDF', path: '/PDFProtect' },
      { name: 'Edit PDF', path: '/PDFEdit' },
    ],
    resources: [
      { name: 'Home', path: '/' },
      { name: 'All Tools', path: '/PDFTools' },
      // { name: 'Pricing', path: '/Pricing' },
      // { name: "Sign In",        path: "/SignIn" },
      // { name: "Sign Up Free",   path: "/SignUp" },
      // { name: "My Profile",     path: "/Profile" },
    ],
    company: [
      { name: 'About Us', path: '/AboutUs' },
      { name: 'Contact', path: '/Contact' },
      { name: 'Disclaimer', path: '/Disclaimer' },
      { name: 'Privacy Policy', path: '/PrivacyPolicy' },
      { name: 'Terms of Service', path: '/TermsOfService' },
      { name: 'Content Policy', path: '/ContentPolicy' },
      { name: 'Cookie Policy', path: '/CookiePolicy' },
    ],
  };

  const socialLinks = [
    { icon: FooterIcons.Facebook, url: 'https://www.facebook.com/people/D-Tech-Studios/61556107977536', label: 'Facebook' },
    { icon: FooterIcons.Twitter, url: 'https://x.com/D_TechStudios', label: 'Twitter' },
    { icon: FooterIcons.LinkedIn, url: 'https://www.linkedin.com/company/d-tech-studios?trk=public_post_follow-view-profile', label: 'LinkedIn' },
    { icon: FooterIcons.Instagram, url: 'https://www.instagram.com/d_techstudios/', label: 'Instagram' },
  ];

  return (
    <footer className="footer">
      <div className="footer-container">
        
        {/* Main Footer Content */}
        <div className="footer-main">
          
          {/* Brand Column */}
          <div className="footer-brand">
            <div className="footer-logo" onClick={() => navigate('/')}>
              <img src={logo} alt="QuickPDFs Logo" className="footer-logo-img" />
              <span className="footer-logo-text">Quick<span className="footer-logo-highlight">PDFs</span>.net</span>
            </div>
            <p className="footer-description">
              Your complete PDF solution 100% free, secure, and easy to use. 
              Transform, edit, and manage your PDF documents with just a few clicks.
            </p>

            {/* Social Links */}
            <div className="footer-social">
              {socialLinks.map((social, index) => (
                <a
                  key={index}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="footer-social-link"
                  aria-label={social.label}
                >
                  <social.icon />
                </a>
              ))}
            </div>
          </div>

          {/* Links Columns */}
          <div className="footer-links">
            
            {/* Products Column */}
            <div className="footer-column">
              <h3 className="footer-column-title">Products</h3>
              <ul className="footer-link-list">
                {footerLinks.products.map((link, index) => (
                  <li key={index}>
                    <a 
                      href={link.path}
                      onClick={(e) => {
                        e.preventDefault();
                        navigate(link.path);
                      }}
                      className="footer-link"
                    >
                      <FooterIcons.ChevronRight className="footer-link-icon" />
                      {link.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Resources Column */}
            <div className="footer-column">
              <h3 className="footer-column-title">Resources</h3>
              <ul className="footer-link-list">
                {footerLinks.resources.map((link, index) => (
                  <li key={index}>
                    <a 
                      href={link.path}
                      onClick={(e) => {
                        e.preventDefault();
                        navigate(link.path);
                      }}
                      className="footer-link"
                    >
                      <FooterIcons.ChevronRight className="footer-link-icon" />
                      {link.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Company Column */}
            <div className="footer-column">
              <h3 className="footer-column-title">Company</h3>
              <ul className="footer-link-list">
                {footerLinks.company.map((link, index) => (
                  <li key={index}>
                    <a 
                      href={link.path}
                      onClick={(e) => {
                        e.preventDefault();
                        navigate(link.path);
                      }}
                      className="footer-link"
                    >
                      <FooterIcons.ChevronRight className="footer-link-icon" />
                      {link.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="footer-bottom">
          <div className="footer-copyright">
            © {currentYear} QuickPDFs.net. All rights reserved.
          </div>
          <div className="footer-legal">
            <a href="/PrivacyPolicy" onClick={(e) => { e.preventDefault(); navigate('/PrivacyPolicy'); }}>Privacy</a>
            <span className="separator">·</span>
            <a href="/TermsOfService" onClick={(e) => { e.preventDefault(); navigate('/TermsOfService'); }}>Terms</a>
            <span className="separator">·</span>
            <a href="/sitemap.xml" target="_blank" rel="noopener noreferrer">Sitemap</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;